
import { Component, Vue } from 'vue-property-decorator';

@Component<FooterComponent>({})
export default class FooterComponent extends Vue {}
